module.exports = __webpack_public_path__ + "img/home2.5ed84023.png";